import { useInstance } from 'intact-vue';
import { inArray } from './useChecked';
import { toggleArray } from '../utils';
export function useTree(data) {
  var instance = useInstance();
  function isSpreaded(key) {
    return inArray(instance.get('spreadKeys'), key);
  }
  function toggleSpreadRow(key) {
    instance.set('spreadKeys', toggleArray(instance.get('spreadKeys'), key));
  }
  function loopData(cb, shouldBreak) {
    if (shouldBreak === void 0) {
      shouldBreak = false;
    }
    var _instance$get = instance.get(),
      childrenKey = _instance$get.childrenKey;
    loopDataWithChildrenKey(data.value, childrenKey, cb, shouldBreak);
  }
  return {
    isSpreaded: isSpreaded,
    toggleSpreadRow: toggleSpreadRow,
    loopData: loopData
  };
}
export function loopDataWithChildrenKey(data, childrenKey, cb, shouldBreak) {
  if (!data) return;
  var index = -1;
  var loop = function loop(data, level, meta) {
    for (var i = 0; i < data.length; i++) {
      index++;
      var value = data[i];
      var ret = cb(value, index, level, meta);
      if (shouldBreak && ret) return true;
      if (childrenKey) {
        var children = value[childrenKey];
        if (Array.isArray(children)) {
          if (loop(children, level + 1, ret)) {
            return true;
          }
        }
      }
    }
    return false;
  };
  loop(data, 0, null);
}